import defaultImage from '../assets/whatsnew-bg-default.webp';
import { StyledImageContainer } from '../styled';

interface ImageProps {
  src?: string;
}

export const Image = ({ src }: ImageProps) => {
  return (
    <StyledImageContainer
      style={{ backgroundImage: `url(${src || defaultImage})` }}
    />
  );
};
